import Vue from 'vue';
import { getParagraph } from './labelRelation';
import { cloneDeep } from 'lodash';

export async function getFieldDictVal({ labelId, keyword, courseId, size = 20, recommendWord, recommendWordType }) {
  const params = { id: labelId, keyword, page: 0, size, coursewareId: courseId };
  if (recommendWord) {
    params.recommendWord = recommendWord;
  }
  if (recommendWordType) {
    params.recommendWord_type = recommendWordType;
  }
  const result = await Vue.prototype.httpPost('/nlp/label/dict/page', params);
  return result.data;
}

export function getReportCases() {
  return Vue.prototype.httpPost('/nlp/case/search/condition/case/list', {});
}

export async function addReportCase(params) {
  return Vue.prototype.httpPost('/nlp/case/search/condition/case/add', params);
}

export function delReportCase(id) {
  const params = {};
  if (id) {
    params.ids = [id];
  } else {
    params.type = 'all';
  }
  return Vue.prototype.httpPost('/nlp/case/search/condition/case/clear', params);
}

export function createReport(params) {
  return Vue.prototype.httpPost('/case/report', params);
}



// WEBPACK FOOTER //
// ./src/service/caseRule.js